import React from "react";

const AppHeader = props => {
  let orgName = props.OrgName || "Organization name ";
  let userName = props.currentUser || "user name ";
  return (
    <div className="AppHeader">
      <div className="orgName"> {orgName}</div>
      <div className="userName">{userName}</div>
      <div />
    </div>
  );
};

export default AppHeader;
